import React from "react";
import Link from "next/link";
import styled from "styled-components";
import { Flex } from "../../styled/Styled.sc";
import { useRouter } from "next/router";

const S = {
  Flex: styled(Flex)`
    overflow-x: auto;
  `,
  Link: styled.a`
    padding: 5px;
    display: block;
    flex: 1;
    cursor: pointer;
    text-align: center;
    background-color: ${(props) => (props.active ? "#4762AB" : "transparent")};
    color: ${(props) => (props.active ? "#fff" : "#333")};
    &:hover {
      background-color: ${(props) => (props.active ? "#3a508c" : "#f5f5f5")};
    }
  `,
};

export const AlphabetLetters = ({ availableLetters }) => {
  const { query } = useRouter();
  const letters = [
    "A",
    "Ą",
    "B",
    "C",
    "Ć",
    "D",
    "E",
    "Ę",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "Ł",
    "M",
    "N",
    "Ń",
    "O",
    "Ó",
    "P",
    "R",
    "S",
    "Ś",
    "T",
    "U",
    "W",
    "V",
    "X",
    "Y",
    "Z",
    "Ź",
    "Ż",
  ].filter((letter) => availableLetters.includes(letter));
  const router = useRouter();
  function createHref(letter) {
    if (router.query.search === letter) {
      return "/autorzy?search=";
    }
    return `/autorzy?search=${letter}`;
  }
  return (
    <S.Flex>
      {letters.map((letter) => (
        <Link shallow={true} href={createHref(letter)} key={letter}>
          <S.Link active={query.search === letter}>{letter}</S.Link>
        </Link>
      ))}
    </S.Flex>
  );
};
